import { useEffect } from 'react';
import {useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';
import ApiStateListeners from "../../vendor/weblink/nguc-javascript-client/ApiStateListeners";
import StateEvent from '../../vendor/weblink/nguc-javascript-client/StateEvent';
import { api } from '../..';

function InvalidAuthTokenWrapper(props: any)  {
	const navigate = useNavigate();

    useEffect(():any => {
        const id:number = ApiStateListeners.addStateListener((event: StateEvent): void => {
            if ( event === StateEvent.invalidToken) {
                api.logout();
                navigate("/login");
                toast.error('Something went wrong.');
            }
        });

        return () => ApiStateListeners.deleteStateListener(id);
        // eslint-disable-next-line
    }, []);

    return props.children;
}

export default InvalidAuthTokenWrapper;